module.exports = __webpack_public_path__ + "assets/tinybots-icon.svg";